import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ManagerUser = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M11.2213 22.0667H9V9H11.4827L15.888 19.1547L20.2933 9H22.7573V22.0667H20.5547V13.2373L16.728 22.0667H15.048L11.2213 13.2373V22.0667Z" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 27.6667C22.4433 27.6667 27.6667 22.4433 27.6667 16C27.6667 9.55673 22.4433 4.33333 16 4.33333C9.55673 4.33333 4.33333 9.55673 4.33333 16C4.33333 22.4433 9.55673 27.6667 16 27.6667ZM16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30Z"
		/>
	</svg>
);

export default ManagerUser;
